/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = None 1 = Allow 2 = Block 3 = Challenge 4 = Log 5 = Bypass
 */
export type AccessListAction = 0 | 1 | 2 | 3 | 4 | 5;

export const AccessListAction = {
  None: 0 as AccessListAction,
  Allow: 1 as AccessListAction,
  Block: 2 as AccessListAction,
  Challenge: 3 as AccessListAction,
  Log: 4 as AccessListAction,
  Bypass: 5 as AccessListAction,
};
